






















































import { Component, Vue, Prop } from 'vue-property-decorator';
import { Route } from 'node_modules/vue-router/types';
import { IIssue, IUser } from '@/lib/interfaces';
import { EIssueStatus } from '@/lib/enums';
import draggable from 'vuedraggable';
import { updateIssue } from '@/services/api.service';
import { mapState } from 'vuex';
import { isTouch } from '@/lib/helpers/common.helper';

interface IGroupedIssues {
  [EIssueStatus.ToDo]: IIssue[];
  [EIssueStatus.InProgress]: IIssue[];
  [EIssueStatus.InReview]: IIssue[];
  [EIssueStatus.InVerification]: IIssue[];
  [EIssueStatus.Done]: IIssue[];
}

@Component({
  components: {
    draggable,
  },
  computed: mapState(['users']),
})
export default class Trello extends Vue {
  /** users from vuex */
  public users!: { string: IUser };
  private isTouch = isTouch();

  @Prop() private issues!: IIssue[];
  @Prop() private statuses!: EIssueStatus[];
  @Prop() private search!: string;
  @Prop() private userHeader!: boolean;

  /** Для того, чтобы несколько трелло компонентов не конфликтовали */
  private get uniqueGroupName() {
    if (this.userHeader) {
      return this.issues[0].member;
    }
    return 'issues';
  }

  private get headerTitle(): string {
    if (this.userHeader) {
      return this.$options.filters!.fullName(this.users[this.issues[0].member!]);
    } else {
      return '';
    }
  }

  private get groupedIssues() {
    const result: IGroupedIssues = {
      [EIssueStatus.ToDo]: [],
      [EIssueStatus.InProgress]: [],
      [EIssueStatus.InReview]: [],
      [EIssueStatus.InVerification]: [],
      [EIssueStatus.Done]: [],
    };
    this.issues.forEach((issue) => {
      if (!this.search || issue.title.toLowerCase().includes(this.search.toLowerCase())) {
        result[issue.status!].push(issue);
      }
    });
    return result;
  }

  private async onIssueMoved(e: any) {
    const oldStatus = this.statuses[e.from.id.split('-')[2]];
    const newStatus = this.statuses[e.to.id.split('-')[2]];
    const issue = this.groupedIssues[oldStatus][e.oldIndex];
    issue.status = newStatus;
    await updateIssue(issue);
  }
}
